namespace Nobox.CRM {
    export interface DealsKanbanResponse {
        ArrHeader?: DealpipelinetypesRow[];
        ArrItem?: DealsRow[];
    }
}
